import styled, { css } from 'styled-components';

export const ValueWrapper = styled.div`
  ${({ theme }) => css`
    height: 23px;
    cursor: pointer;
    background-color: ${p => p.selected ? '#FFFFFF' : (theme?.colour?.primary ?? "#1DBD6B")};
    color: ${p => p.selected ? (theme?.colour?.primary ?? "#1DBD6B") : '#F4FCF8'};
    border-radius: 31px;
    padding: 5px 16px;

    &:hover {
      font-weight: ${p => p.selected ? 400 : 600};
    }
  `}
`;
